import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { IApiOrderListItem } from '../../model/api-modules';
import {
  BILLING_PREFIX,
  BILLING_PROXY_EDIT,
  BILLING_PROXY_VIEW,
} from '../config';
import { store } from '../../store';

export const assignStudioQuery = (url: string, studioId?: string) => {
  const curStudioID =
    studioId || store.getState().studio.selectStudio?.studioID;
  if (curStudioID) {
    if (url.includes('?')) {
      return `${url}&studioID=${curStudioID}`;
    }

    return `${url}?studioID=${curStudioID}`;
  }
  return url;
};

export const getOrderList = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/order/list?studio_id=${studioId}&page=1&size=99999`
      );
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<{
        readonly list: ReadonlyArray<IApiOrderListItem>;
      }>(response, 'data');
      return res.list;
    } catch (error) {
      console.log('failed: getOrderList', error);
      return false;
    }
  });

export const getOrderDetail = (orderId: string, studioId?: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/order/detail?order_id=${orderId}`,
        studioId
      );
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IApiOrderListItem>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getOrderList', error);
      return;
    }
  });

export const confirmOrder = (orderId: string, operator: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(`${BILLING_PROXY_EDIT}/api/order/commit`);
      const response = await api.commonRequest('POST', url, {
        order_id: orderId,
        operator,
      });
      const res = await parsedResponse<string>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getOrderList', error);
      return;
    }
  });

export const cancelOrder = (orderId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PREFIX}/order/${orderId}/cancel`
      );
      const response = await api.commonRequest('POST', url);
      const res = await parsedResponse<string>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getOrderList', error);
      return;
    }
  });
